import React from 'react';
import { Link } from 'react-router-dom';

function SiteNav() {
  return (
    <nav className="site-nav">
      <Link to="/" className="site-nav-brand">
        the daily <span className="site-nav-brand-accent">art</span>
      </Link>
      <div className="site-nav-links">
        <a href="/#story" className="site-nav-link">About</a>
        <Link to="/blog" className="site-nav-link">Blog</Link>
        <Link to="/Gallery" className="site-nav-link">Gallery</Link>
        <Link to="/?canvas=1" className="site-nav-cta">Start Drawing</Link>
      </div>
    </nav>
  );
}

export default SiteNav;
